module.exports = __webpack_public_path__ + "img/08_Flexible Character.b7ab352d.svg";